<template>
  <div v-if="showEvent && show" class="date">
    <div class="col">
      <p>
        <i class="fa fa-calendar"/>
        <NuxtTime :datetime="showEvent.startsAt" weekday="long" day="numeric" :locale="language.locale"/>
      </p>
      <p>
        <NuxtTime :datetime="showEvent.startsAt" month="long" year="numeric" :locale="language.locale"/>
      </p>
    </div>
    <div class="col">
      <p>
        <i class="fa fa-clock"/>
        <NuxtTime :datetime="showEvent.startsAt" hour="numeric" minute="numeric" :hour12="true" :locale="language.locale"/>
      </p>
    </div>
    <div class="col">
      <i class="fa fa-map-marker"/>
      <p>{{ show.location ? `${show.location.name}` : 'Virtual' }}</p>
      <p v-if="!show.isOnline && show.location">{{ show.location.address }}. {{ show.location?.locality }}
        <a href="" class="bt_showMap" @click.prevent="showMap = !showMap">{{ showMapText }}</a>
      </p>
    </div>
    <p>{{show.description}}</p>
    <div v-if="showMap" class="map" style="display: block">
      <img :src="show.googleMapUrl" alt="map">
    </div>
    <slot/>
  </div>
</template>
<script lang="ts">
import {defineComponent, type PropType} from 'vue'
import type {ShowEvent, ShowPublicObject} from "~/api/generated";

export default defineComponent({
  props: {
    show: Object as PropType<ShowPublicObject>,
    showEvent: Object as PropType<ShowEvent>,
  },
  data() {
    return {
      showMap: false,
      language: useI18n()
    }
  },
  computed: {
    showMapText() {
      const i18n = useI18n();
      return this.showMap ? i18n.t('show.hideMap') : i18n.t('show.showMap')
    },
  },
})
</script>
<style scoped>

</style>